var map = {
	"./br/PT/S1/bigwin.png": 63401,
	"./in/EN/S1/bigwin.png": 31273,
	"./ph/EN/S1/bigwin.png": 43795,
	"./ph/EN/S2/bigwin.png": 23399,
	"./vn/VI/S1/bigwin.png": 75125
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 74524;